import { type IconTypes } from '@ics-portal/guardian';
import { ComponentCreateRequestStatusCode } from '@gql/graphql';
import { humanizeRequestStatus } from '@pages/notification-components/utils/humanizeRequestStatus';

interface StatusIconMapEntry {
    icon: IconTypes;
    colorClass: string;
    tooltip: string;
}

export const statusIconMap: Record<string, StatusIconMapEntry> = {
    [ComponentCreateRequestStatusCode.Created]: {
        icon: 'add_circle',
        colorClass: 'text-gr50',
        tooltip: humanizeRequestStatus(
            ComponentCreateRequestStatusCode.Created,
        ),
    },
    [ComponentCreateRequestStatusCode.Approved]: {
        icon: 'check_circle',
        colorClass: 'text-gr50',
        tooltip: humanizeRequestStatus(
            ComponentCreateRequestStatusCode.Approved,
        ),
    },
    [ComponentCreateRequestStatusCode.Forwarded]: {
        icon: 'send_money',
        colorClass: 'text-b50',
        tooltip: humanizeRequestStatus(
            ComponentCreateRequestStatusCode.Forwarded,
        ),
    },
    [ComponentCreateRequestStatusCode.Removed]: {
        icon: 'block',
        colorClass: 'text-r50',
        tooltip: humanizeRequestStatus(
            ComponentCreateRequestStatusCode.Removed,
        ),
    },
    [ComponentCreateRequestStatusCode.Replaced]: {
        icon: 'published_with_changes',
        colorClass: 'text-b50',
        tooltip: humanizeRequestStatus(
            ComponentCreateRequestStatusCode.Replaced,
        ),
    },
    [ComponentCreateRequestStatusCode.ApprovalPending]: {
        icon: 'nest_secure_alarm',
        colorClass: 'text-st50',
        tooltip: humanizeRequestStatus(
            ComponentCreateRequestStatusCode.ApprovalPending,
        ),
    },
};
